import { OrderKeys } from '~src/ts/models/OrderKeys';
import { SortOptions } from '~src/ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/ts/models/sort/SortOptionDefinitions';

export const connectedApplicationSortOptions: OptionsDictionary = {
  [OrderKeys.name]: SortOptions.name,
  [OrderKeys.connectedApplicationClientId]: SortOptions.connectedApplicationClientId,
  [OrderKeys.connectedApplicationStatus]: SortOptions.connectedApplicationStatus,
  [OrderKeys.createdAt]: SortOptions.createdAt,
  [OrderKeys.connectedApplicationScope]: SortOptions.connectedApplicationScope,
  [OrderKeys.connectedApplicationDomains]: SortOptions.connectedApplicationDomains,
};